import { API_SECONDARY_MARKETING_AI_EXTRACT, API_SECONDARY_MARKETING_SCREEN_DATA } from 'config'
import Api from 'services/api'

export type OriginatorLockAiExtractData = {
  LockDays: number | null
  LockFloating: boolean | null
  LockExtension1Days: number | null
  LockExtension2Days: number | null
  LockExtension3Days: number | null
  LockStartDate: string | null
  LockExpirationDate: string | null
  LockCanceledDate: string | null
  UnextendedLockExpDate: string | null
  BuyCommitmentNo: string | null
  RegulatoryLockDateOV: string | null
  sourceFile?: { fileKey: string; name: string }
}

export const getSecondaryMarketingScreenData = () => {
  return Api.get(API_SECONDARY_MARKETING_SCREEN_DATA)
}

export const postSecondaryMarketingScreenData = (data: Record<string, any>) => {
  return Api.post(API_SECONDARY_MARKETING_SCREEN_DATA, data)
}

export const extractOriginatorLockFromPdf = (files: Array<{ fileKey: string; name: string }>) => {
  return Api.post(API_SECONDARY_MARKETING_AI_EXTRACT, { files }, {}, { timeout: 0 })
}
